import { useState, useCallback } from "react";
import { db } from "services/firebaseConfig";
import {
  collection,
  query,
  getDocs,
  doc,
  deleteDoc,
  updateDoc,
  orderBy,
} from "firebase/firestore";
import toast from "react-hot-toast";

export const useCredits = () => {
  const [credits, setCredits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCredits = useCallback(async () => {
    setIsLoading(true);
    try {
      const q = query(collection(db, "credits"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      const fetchedCredits = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        fetchedCredits.push({
          id: doc.id,
          ...data,
          expirationDate: data.expirationDate?.toDate
            ? data.expirationDate.toDate()
            : null,
          createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : null,
        });
      });

      setCredits(fetchedCredits);
    } catch (error) {
      console.error("Erro ao buscar créditos:", error);
      toast.error("Erro ao carregar lista de créditos.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const deleteCredit = async (creditId) => {
    if (window.confirm("Deseja realmente dar baixa/excluir este crédito?")) {
      try {
        await deleteDoc(doc(db, "credits", creditId));
        toast.success("Crédito baixado com sucesso.");
        fetchCredits();
      } catch (error) {
        console.error("Erro ao excluir crédito:", error);
        toast.error("Erro ao excluir crédito.");
      }
    }
  };

  const updateCredit = async (creditId, updatedData) => {
    try {
      const creditRef = doc(db, "credits", creditId);
      await updateDoc(creditRef, updatedData);
      toast.success("Crédito atualizado com sucesso.");
      fetchCredits();
      return true;
    } catch (error) {
      console.error("Erro ao atualizar crédito:", error);
      toast.error("Erro ao atualizar o crédito.");
      return false;
    }
  };

  return {
    credits,
    isLoading,
    fetchCredits,
    deleteCredit,
    updateCredit,
  };
};
